import { useState } from "react";
import api from "../../../utils/axios";

const SECTION_DEFAULT_SETTINGS = {
    hero: {
        title: "",
        subtitle: "",
        alignment: "center",
        variant: "large",
        button_text: "",
        button_url: ""
    },
    rich_text: {
        title: "",
        body: "<p></p>",
        alignment: "left"
    },
    news_ticker: {
        title: "Latest Updates",
        speed: "medium",
        direction: "left",
        pause_on_hover: true,
        show_label: true
    },
    accordion: {
        title: "",
        variant: "simple"
    },
    list: {
        title: "",
        variant: "link-list"
    },
    cards: {
        title: "",
        columns: 3
    },
    downloads: {
        title: "",
        description: ""
    },
    gallery: {
        title: "",
        columns: 3
    },
    image_text: {
        title: "",
        body: "<p></p>",
        image_id: null,
        image_position: "top",
        columns_ratio: "sidebar"
    },
    quote: {
        quote_text: "",
        author: ""
    },
    spacer: {
        height: "40px"
    }
};


function SectionCreateForm({ pageId, existingSections, onCreated }) {
    const [form, setForm] = useState({
        section_name: "",
        section_type: "rich_text",
        zone: "main",
        sort_order: 1,
        is_visible: true,
        settings_json: SECTION_DEFAULT_SETTINGS.rich_text
    });

    const updateField = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const changeType = (type) => {
        setForm((prev) => ({
            ...prev,
            section_type: type,
            settings_json: SECTION_DEFAULT_SETTINGS[type] || {}
        }));
    };

    const autoNextOrder = (zone) => {
        const count = existingSections.filter((s) => s.zone === zone).length;
        return count + 1;
    };

    const changeZone = (zone) => {
        setForm((prev) => ({
            ...prev,
            zone,
            sort_order: autoNextOrder(zone)
        }));
    };

    const submit = async (e) => {
        e.preventDefault();

        await api.post(`/pages/${pageId}/sections`, form);
        onCreated();

        setForm({
            section_name: "",
            section_type: "rich_text",
            zone: "main",
            sort_order: autoNextOrder("main"),
            is_visible: true,
            settings_json: SECTION_DEFAULT_SETTINGS.rich_text
        });
    };

    return (
        <form onSubmit={submit} className="admin-form">
            <h3>Add Section</h3>

            <label className="list-row" align={"left"}><span className="list-text">Section name</span>
                <input
                    name={`section_name`}
                    value={form.section_name}
                    onChange={(e) => updateField("section_name", e.target.value)}
                    placeholder="Homepage Intro"
                    required
                />
            </label>

            <label className="list-row" align={"left"}><span className="list-text">Section type</span>
                <select
                    name={`section_type`}
                    value={form.section_type}
                    onChange={(e) => changeType(e.target.value)}
                >
                    <option value="hero">Hero</option>
                    <option value="rich_text">Rich Text</option>
                    <option value="news_ticker">News Ticker</option>
                    <option value="accordion">Accordion</option>
                    <option value="list">List</option>
                    <option value="cards">Cards</option>
                    <option value="downloads">Downloads</option>
                    <option value="gallery">Gallery</option>
                    <option value="image_text">Image + Text</option>
                    <option value="quote">Quote</option>
                    <option value="spacer">Spacer</option>
                </select>
            </label>

            <label className="list-row" align={"left"}><span className="list-text">Zone</span>
                <select
                    name={`zone`}
                    value={form.zone}
                    onChange={(e) => changeZone(e.target.value)}
                >
                    <option value="main">Main 65%</option>
                    <option value="sidebar">Sidebar 30%</option>
                </select>
            </label>

            <label className="list-row" align={"left"}><span className="list-text">Order in zone</span>
                <input
                    name={`order`}
                    type="number"
                    min="1"
                    value={form.sort_order}
                    onChange={(e) => updateField("sort_order", Number(e.target.value))}
                />
            </label>

            <label className="list-row" align={"left"}>
                <input
                    name={`sort_order`}
                    type="checkbox"
                    checked={form.is_visible}
                    onChange={(e) => updateField("is_visible", e.target.checked)}
                />
                Visible
            </label>

            <button className={"button"} type="submit">Add Section</button>
        </form>
    );
}

export default SectionCreateForm;